<a (click)="downloadResume()">
  <ng-content></ng-content>
</a>
